import { render, staticRenderFns } from "./GetPriceList.vue?vue&type=template&id=3c1c20b3&"
import script from "./GetPriceList.vue?vue&type=script&lang=js&"
export * from "./GetPriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports